import { render, staticRenderFns } from "./ChatTalkBody.vue?vue&type=template&id=7e2f1f63&scoped=true&"
import script from "./ChatTalkBody.vue?vue&type=script&lang=js&"
export * from "./ChatTalkBody.vue?vue&type=script&lang=js&"
import style0 from "./ChatTalkBody.vue?vue&type=style&index=0&id=7e2f1f63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2f1f63",
  null
  
)

export default component.exports